module.exports = __webpack_public_path__ + "img/japanese-“discount”-button.ee885eaa.png";